import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { UIService } from '../../core/services/utils/ui.service';
import { LicenseStatusModel } from '../../core/models/view-models/license-models/license-status.model';
import { LicenseService } from '../../core/services/http-services/license.service';
import { AppConstants } from '../../app.constants';

@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnDestroy {

  public isAdminTabDisabled: boolean = false;
  public isToShowGrayedBg: boolean = false;
  public adminRole = AppConstants.ADMINISTRATOR_ROLE;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly licenseService: LicenseService,
    private readonly router: Router,
    private readonly uiService: UIService
  ) {
    if (this.licenseService.licenseStatusModel) {
      this.isAdminTabDisabled = !this.licenseService.licenseStatusModel.Status;
    }

    this.subscriptions.add(
      this.licenseService.licenseStatusModel$.subscribe((licenseStatusModel: LicenseStatusModel) => {
        if (window.location.href.endsWith('Admin')) {
          if (licenseStatusModel && licenseStatusModel.Status) {
            this.router.navigate(['/Admin/UsersTable']);
          } else {
            this.router.navigate(['/Admin/License']);
          }
        }
        this.isAdminTabDisabled = licenseStatusModel && !licenseStatusModel.Status;
      })
    );

    this.subscriptions.add(
      this.uiService.displayConfigToolIsToShowBackgroundChanged.subscribe((state: boolean) =>
        setTimeout(() => {
          this.isToShowGrayedBg = state;
        }))
    );
  }

  isAllowedByLicense(): boolean {
    return this.licenseService.isAllowedByLicense(AppConstants.WALL_FEATURE_NAME, true);
  }

  onMenuClick(): void {
    this.licenseService.isNavigateToAdmin = true;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
